import { useMemo } from 'react';
import { useGetAccessManager } from 'services/hooks/queries';
import { User, WorkflowSummary } from 'types/accessManager.type';
import { UserRole } from 'types/userRoles';

export type WithWorkflowAssignments<T extends { id: string }> = T & {
    workflow_assignments: WorkflowSummary[];
    is_agent: boolean;
};

export const useAgentsWithWorkflowAssignments = <T extends { id: string }>(
    agents: T[]
): WithWorkflowAssignments<T>[] => {
    const { accessManagerData } = useGetAccessManager();

    const userById = useMemo(() => {
        const map = new Map<string, User>();
        accessManagerData?.users?.forEach((user) => {
            map.set(user.id, user);
        });
        return map;
    }, [accessManagerData?.users]);

    return useMemo(
        () =>
            agents.map((agent) => {
                const matchedUser = userById.get(agent.id);
                return {
                    ...agent,
                    workflow_assignments: matchedUser?.workflow_assignments ?? [],
                    is_agent: matchedUser ? matchedUser.roles.includes(UserRole.AGENT) : true,
                };
            }),
        [agents, userById]
    );
};
